<template>
<div class="alert-wrapper">
    <div v-for="alert in alerts" :key="alert.id" class="alert alert-dismissible fade show mb-0" role="alert" :class="'alert-' + alert.context">
      {{ alert.msg }}
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="dismissAlertById(alert.id)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <hr>
      <mz-date-display :timestamp="alert.timestamp"></mz-date-display>
    </div>
</div>
</template>

<script>
import DateDisplay from '@/components/general/DateDisplay'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'alerts',
  data () {
    return {
      device: null
    }
  },
  computed: {
    ...mapGetters(['alerts'])
  },
  methods: {
    ...mapMutations(['dismissAlertById'])
  },
  components: {
    mzDateDisplay: DateDisplay
  }
}
</script>

<style>
.alert-wrapper {
  z-index: 9999;
  position: fixed;
  top: 0;
  width: 50%;
  margin-left: 25%;
}

.alert {
  /* border-radius: 0; */
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-top-width: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/general/Alert.vue